export enum EPermissions {
  DASHBOARD_READ = 'dashboard.read',

  JOB_CALENDAR_READ = 'job-calendar.read',

  PERMISSION_CREATE = 'permission.create',
  PERMISSION_READ = 'permission.read',
  PERMISSION_UPDATE = 'permission.update',
  PERMISSION_DELETE = 'permission.delete',

  ADMIN_CREATE = 'admin.create',
  ADMIN_READ = 'admin.read',
  ADMIN_UPDATE = 'admin.update',
  ADMIN_DELETE = 'admin.delete',

  AGENT_CREATE = 'agent.create',
  AGENT_READ = 'agent.read',
  AGENT_UPDATE = 'agent.update',
  AGENT_DELETE = 'agent.delete',

  FORM_CREATE = 'form.create',
  FORM_READ = 'form.read',
  FORM_UPDATE = 'form.update',
  FORM_DELETE = 'form.delete',
  FORM_DOWNLOAD = 'form.download',

  JOB_CREATE = 'job.create',
  JOB_READ = 'job.read',
  JOB_UPDATE = 'job.update',
  JOB_DELETE = 'job.delete',
  JOB_DOWNLOAD = 'job.download',

  JOB_APPROVAL_READ = 'job-approval.read',
  JOB_APPROVAL_UPDATE = 'job-approval.update',
  JOB_APPROVAL_DOWNLOAD = 'job-approval.download',

  WORK_ORDER_INCOMING_READ = 'work-order-incoming.read',
  WORK_ORDER_INCOMING_UPDATE = 'work-order-incoming.update',
  WORK_ORDER_INCOMING_DOWNLOAD = 'work-order-incoming.download',

  WORK_ORDER_OUTGOING_CREATE = 'work-order-outgoing.create',
  WORK_ORDER_OUTGOING_READ = 'work-order-outgoing.read',
  WORK_ORDER_OUTGOING_UPDATE = 'work-order-outgoing.update',
  WORK_ORDER_OUTGOING_DELETE = 'work-order-outgoing.delete',
  WORK_ORDER_OUTGOING_DOWNLOAD = 'work-order-outgoing.download',

  ACTIVITY_LOG_READ = 'activity-log.read',

  ORGANIZATION_READ = 'organization.read',

  COMPANY_CREATE = 'company.create',
  COMPANY_READ = 'company.read',
  COMPANY_UPDATE = 'company.update',
  COMPANY_DELETE = 'company.delete',

  DEPARTMENT_CREATE = 'department.create',
  DEPARTMENT_READ = 'department.read',
  DEPARTMENT_UPDATE = 'department.update',
  DEPARTMENT_DELETE = 'department.delete',

  JOB_TEMPLATE_CREATE = 'job-template.create',
  JOB_TEMPLATE_READ = 'job-template.read',
  JOB_TEMPLATE_UPDATE = 'job-template.update',
  JOB_TEMPLATE_DELETE = 'job-template.delete',
}

export type TPermissions = keyof typeof EPermissions
